module.exports = __webpack_public_path__ + "media/images/doctor_PNG15987-aba224dcff05fdc94c0ce872654ed37c.png";